module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-hamburger-5249cf57.svg";